var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "attachment-uploader" }, [
    _vm.attachments && _vm.attachments.length > 0
      ? _c(
          "div",
          { staticClass: "attachment-list mt-10" },
          _vm._l(_vm.attachments, function(attachment, index) {
            return _c(
              "div",
              { key: index, staticClass: "attachment-item" },
              [
                _c(
                  "el-tag",
                  {
                    attrs: { size: "medium", closable: "" },
                    on: {
                      close: function($event) {
                        return _vm.handleRemoveAttachment(attachment)
                      },
                      click: function($event) {
                        return _vm.downloadAttachment(attachment)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-document" }),
                    _vm._v("\n\t\t\t\t" + _vm._s(attachment.name) + "\n\t\t\t")
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showTabbedPanel
      ? _c(
          "div",
          { staticClass: "add-attachment-button mt-10" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini", disabled: _vm.loading },
                on: {
                  click: function($event) {
                    _vm.showTabbedPanel = true
                  }
                }
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("AttachmentUploader.addAttachments")) +
                    "\n\t\t"
                )
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showTabbedPanel
      ? _c(
          "div",
          { staticClass: "tabbed-panel" },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("AttachmentUploader.filesystem"),
                      name: "filesystem"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "upload-container" },
                      [
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            attrs: {
                              action: "",
                              "auto-upload": false,
                              "on-change": _vm.handleFileChange,
                              "file-list": _vm.fileList,
                              multiple: true,
                              limit: 10,
                              "on-exceed": _vm.handleExceed,
                              "on-remove": _vm.handleFileRemove,
                              disabled: _vm.loading,
                              drag: ""
                            }
                          },
                          [
                            _c("i", { staticClass: "el-icon-upload" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "el-upload__text" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t("AttachmentUploader.dropFilesHere")
                                  ) +
                                  " "
                              ),
                              _c("em", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("AttachmentUploader.orClickToSelect")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                attrs: { slot: "tip" },
                                slot: "tip"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "AttachmentUploader.attachmentUploadTip"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.fileList.length > 0
                          ? _c(
                              "div",
                              { staticClass: "upload-actions" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "selected-files-info" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-document"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.fileList.length) +
                                        " " +
                                        _vm._s(
                                          _vm.fileList.length === 1
                                            ? _vm.$t(
                                                "AttachmentUploader.fileSelected"
                                              )
                                            : _vm.$t(
                                                "AttachmentUploader.filesSelected"
                                              )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      loading: _vm.loading
                                    },
                                    on: { click: _vm.uploadFiles }
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-upload" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("AttachmentUploader.uploadNow")
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: { click: _vm.closeTabbedPanel }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("AttachmentUploader.cancel")) +
                        "\n\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }